<template lang="pug">
v-container(grid-list-md v-if="upload" class="menu")
    v-layout(wrap)
        v-flex(lg2 md2 xs12 v-if="upload.count")
            v-text-field(dense v-model="upload.count" label="Jumlah Data" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
        v-flex(lg9 md9 xs12 v-if="upload.filename")
            v-text-field(dense v-model="upload.filename" label="Nama File" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-file
    v-layout(wrap)
        v-flex(lg2 md2 xs12 v-if="upload.instanceId")
            v-text-field(dense v-model="upload.instanceId" label="Kode Instansi" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
        v-flex(lg2 md2 xs12 v-if="upload.treasuryId")
            v-text-field(dense v-model="upload.treasuryId"  label="Kode Bendahara" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
    v-layout(wrap)
        v-flex(lg2 md2 xs12 v-if="payrollStatus && payrollStatus.payrollId")
            v-text-field(dense v-model="payrollStatus.payrollId" label="Id SI Gaji" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
        v-flex(lg2 md2 xs12 v-if="payrollStatus && payrollStatus.statusUpload")
            v-text-field(dense v-model="payrollStatus.statusUpload" label="Status Upload" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
        v-flex(lg2 md2 xs12 v-if="payrollStatus && payrollStatus.statusPosting")
            v-text-field(dense v-model="payrollStatus.statusPosting" label="Status Posting" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
    v-layout(wrap)
        v-flex(lg11 md11 xs12 v-if="payrollStatus && payrollStatus.messageUpload")
            v-textarea(dense v-model="payrollStatus.messageUpload" label="Keterangan Status Upload SI Gaji" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
        v-flex(lg11 md11 xs12 v-if="payrollStatus && payrollStatus.messagePosting")
            v-textarea(dense v-model="payrollStatus.messagePosting" label="Keterangan Status Posting SI Gaji" readonly)
                template(v-slot:prepend)
                    v-icon(color="primary") mdi-check-circle
    v-layout(wrap)
        v-flex(lg3 md3 xs12)
            f-decimalbox(v-model="upload.amount" label="Nominal" readonly :template="true")
        v-flex(lg2 md2 xs12)
            f-decimalbox(v-model="upload.fee" label="Biaya Admin" readonly :template="true")
        v-flex(lg3 md3 xs12)
            f-decimalbox(v-model="upload.total" label="Total" readonly :template="true")
    div(class="text-center justify-center ma-2 menu-btn" v-if="monitoring")
        v-btn(color="success" @click="doDownload(upload)") Cetak
            v-icon mdi-file-download-outline
    v-layout(wrap)
        v-flex(lg12 md12 xs12)
            v-stepper(v-model="step")
                v-stepper-items
                    v-stepper-content(step="1")
                        v-data-table(
                            hide-default-footer 
                            :headers="headers" 
                            :items="listDetail" 
                            :items-per-page="itemsPerPage"
                            @page-count="pageCount = $event"
                            :page.sync="page"
                        )
                            template(v-slot:item.status="{item}")
                                v-chip(small v-if="item.status" :color="item.status == 'SUCCESS' ? 'info' : item.status == 'FAILED' ? 'error' : 'warning'" dark) {{ item.status }}
                            template(v-slot:item.transactionId="{item}")
                                div(v-if="item.transactionResponse && item.transactionResponse.journalDetail && item.transactionResponse.journalDetail.transactionId") {{ item.transactionResponse.journalDetail.transactionId }}
                            template(v-slot:item.kmg="{item}")
                                div(v-if="item.additionalData") {{ item.additionalData.kmgAmount | decimalformat }}
                            template(v-slot:item.bankCode="{item}")
                                div(v-if="item.additionalData && item.additionalData.bankId") {{ item.additionalData.bankId }}
                            template(v-slot:item.productDetail="{item}")
                                div(v-if="item.additionalData && item.additionalData.productId") {{ item.additionalData.productId }}
                            template(v-slot:item.denom="{item}")
                                div(v-if="item.additionalData && item.additionalData.denom") {{ item.additionalData.denom | decimalformat }}
                            template(v-slot:item.amount="{item}")
                                div {{ item.amount | decimalformat }}
                            template(v-slot:item.fee="{item}")
                                div {{ item.fee | decimalformat }}
                            template(v-slot:item.total="{item}")
                                div {{ item.total | decimalformat }}
                            template(v-slot:item.action="{item}")
                                v-layout(wrap justify-center class="menu-btn-sm")
                                    v-btn(color="primary" @click="detail(item)" class="ma-1" v-if="item.dataResponse && item.additionalData && !(item.additionalData.productId == 'INQ_ACCOUNT' || item.additionalData.productId == 'TRF_INT')") Detail
                                        v-icon mdi-arrow-right-circle
                        div(class="text-xs-center")
                            v-pagination(v-model="page" :length="pageCount")
                    v-stepper-content(step="2")
                        v-container(grid-list-md v-if="transaction && transaction.journalDetail")
                            v-layout(wrap)
                                v-flex(lg6 md6 xs12 v-if="transaction.journalDetail.transactionId")
                                    v-text-field(dense v-model="transaction.journalDetail.transactionId" label="No. Transaksi Bank" readonly)
                                        template(v-slot:prepend)
                                            v-icon(color="primary") mdi-receipt
                                        template(v-slot:append)
                                            v-chip(small color="primary" class="my-1") {{transaction.journalDetail.settlementDate | dateformat}}
                        f-transaction-content(:productId="productId" :productGroup="productGroup" :content="content" :request="data" :transaction="transaction")
                        div(justify-center style="text-align: center;" class="ma-2 menu-btn")
                            v-btn(class="mx-1" @click="doBack") Kembali
                                v-icon mdi-arrow-left-circle
                                
</template>
<script>
export default {
    name: "FUploadTransactionTable",
    props: ["upload", "payrollStatus","monitoring"],
    data() {
        return {
            headers: [
                {text: '', value: 'status', sortable: false, align: "center", width: "120px", class: "primary--text"},
                {text: 'No Pelanggan', value: 'customerId', sortable: false, width: "150px", class: "primary--text"},
                {text: 'Nama', value: 'name', sortable: false, width: "250px", class: "primary--text"},
                {text: 'Nominal', align: "right", value: 'amount', sortable: false, width: "150px", class: "primary--text"},
                {text: 'Biaya', align: "right", value: 'fee', sortable: false, width: "150px", class: "primary--text"},
                {text: 'Total', align: "right", value: 'total', sortable: false, width: "150px", class: "primary--text"},
                {text: 'Pesan', value: 'errorMessage', sortable: false, width: "250px", class: "primary--text"},
                {text: '', value: 'action', sortable: false, width: "150px"},
            ],
            listData: [],
            itemsPerPage: 5,
            criteria: "",
            pageCount: 0,
            page: 1,
            item: null,
            productId: "",
            productGroup: "",
            content: null,
            data: null,
            transaction: null,
            step: "1",
            statusUpload: "",
            statusPosting: "",
            listDetailData:null
        }
    },
    mounted() {
        this.doInit(this.upload);
    },
    watch: {
        upload(val) {
            this.doInit(val);
        }
    },
    computed: {
        listDetail(){
            return this.listData.sort((a, b) => (a.status > b.status) ? 1 : -1);
        },
    },
    methods: {
        doInit(value){
            this.step = "1";
            this.setHeader();
            this.listData = value ? value.listDetail : [];
        },
        doReset(){
            this.itemsPerPage = 10;
            this.criteria = "";
            this.pageCount = 0;
            this.page = 1;
            this.statusUpload = "";
            this.statusPosting = "";
        },
        detail(item){
            this.$emit("detail", item);
            this.item = item;
            if (this.item.additionalData) {
                this.productId = this.item.additionalData.productId;
                this.productGroup = this.item.additionalData.productGroup;
                this.content = this.item.dataResponse;
                this.data = this.item.dataRequest;
                this.transaction = this.item.transactionResponse
            }
            this.step = "2";
            this.$emit("hideButton");
        },
        doBack() {
            this.step = "1";
            this.$emit("showButton");
        },
        setHeader() {
            if (this.upload) {
                if(this.upload.productId == 'SP2D_PAYROLL' || this.upload.productId == 'KASDA_PAYROLL'|| this.upload.productId == 'KASDA_PAYROLL_MULTI'){
                    this.headers = [
                        {text: '', value: 'status', sortable: false, align: "center", width: "120px", class: "primary--text"},
                        {text: 'No Rekening', value: 'customerId', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Nama', value: 'name', sortable: false, width: "250px", class: "primary--text"},
                        {text: 'Angsuran Kredit/Pembiayaan', align: "right", value: 'kmg', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Gaji Netto', align: "right", value: 'total', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Pesan', value: 'errorMessage', sortable: false, width: "250px", class: "primary--text"},
                        {text: '', value: 'action', sortable: false, width: "150px"},
                    ];
                } else if(this.upload.productId == 'SP2D_MLT_TRF' || this.upload.productId == 'KASDA_MLT_TRF') {
                    this.headers = [
                        {text: '', value: 'status', sortable: false, align: "center", width: "120px", class: "primary--text"},
                        {text: 'Jenis Transaksi', value: 'productDetail', sortable: false, width: "100px", class: "primary--text"},
                        {text: 'Kode Bank', value: 'bankCode', sortable: false, width: "100px", class: "primary--text"},
                        {text: 'No Rekening', value: 'customerId', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Nama', value: 'name', sortable: false, width: "250px", class: "primary--text"},
                        {text: 'Nominal', align: "right", value: 'amount', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Biaya', align: "right", value: 'fee', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Total', align: "right", value: 'total', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Pesan', value: 'errorMessage', sortable: false, width: "250px", class: "primary--text"},
                        {text: 'No Arsip', value: 'transactionId', align: "center", sortable: false, width: "120px", class: "primary--text"},
                        {text: '', value: 'action', sortable: false, width: "150px"},
                    ];
                } else if(this.upload.productGroup.includes('PURCHASE')) {
                    this.headers = [
                        {text: '', value: 'status', sortable: false, align: "center", width: "120px", class: "primary--text"},
                        {text: 'No Pelanggan', value: 'customerId', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Nama', value: 'name', sortable: false, width: "250px", class: "primary--text"},
                        {text: 'Denom', value: 'denom', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Nominal', align: "right", value: 'amount', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Biaya', align: "right", value: 'fee', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Total', align: "right", value: 'total', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Pesan', value: 'errorMessage', sortable: false, width: "250px", class: "primary--text"},
                        {text: '', value: 'action', sortable: false, width: "150px"},
                    ];
                } else if(this.upload.productGroup.includes('PAYMENT')){
                    this.headers = [
                        {text: '', value: 'status', sortable: false, align: "center", width: "120px", class: "primary--text"},
                        {text: 'No Pelanggan', value: 'customerId', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Nama', value: 'name', sortable: false, width: "250px", class: "primary--text"},
                        {text: 'Nominal', align: "right", value: 'amount', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Biaya', align: "right", value: 'fee', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Total', align: "right", value: 'total', sortable: false, width: "150px", class: "primary--text"},
                        {text: 'Pesan', value: 'errorMessage', sortable: false, width: "250px", class: "primary--text"},
                        {text: '', value: 'action', sortable: false, width: "150px"},
                    ];
                }
            }
        },
        doDownload(data) {
            this.listDetailData = data.listDetail;
            this.$progress.show(true);
            this.$http.post("api/file/upload-result", this.upload, { responseType: "arraybuffer" })
                .then(success => {
                    var fileUrl = window.URL.createObjectURL(new Blob([success.data], {type: "application/vnd.ms-excel"}));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileUrl;
                    fileLink.setAttribute('download', 'DATA_UPLOAD - ' + data.referenceChannel + '.xlsx');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }, err => {
                    this.$message.error(err.response.data.message);
                }).finally(() => this.$progress.show(false));
        },
    },
}
</script>